export const GET_BOD2_SUMMARY = "GET_BOD2_SUMMARY";
export const GET_BOD2_GAP = "GET_BOD2_GAP";
export const GET_BOD3_SUMMARY = "GET_BOD3_SUMMARY";
export const GET_BOD3_GAP = "GET_BOD3_GAP";
